// extracted by mini-css-extract-plugin
export default {"about-page":"About_about-page__fVaP9","fade-in":"About_fade-in__zRCpl","bg-text":"About_bg-text__1iXN1"};